import React, {useEffect, useMemo, useRef, useState} from 'react';
import PropTypes from 'prop-types';
import CardMedia from "@material-ui/core/CardMedia";
import Card from "@material-ui/core/Card";
import getParamsFromString from "../../Utils/getParamsFromString";
import request from "../../../../Services/API/Requests";
import JsonScreenHoc from "../../../../HocHelpers/JsonScreenHoc";
import {generateBorder} from "../../Utils/generateStyles";
import {uid} from "react-uid";
import {Loading} from "../../../../Utils/Loading/Loading";
import {useSelector} from "react-redux";
import {useCurrentResolution} from "../../../../Hooks/useCurrentResolution";
import {useResponsiveStyles} from "../../../../Hooks/useResponsiveStyles";
import {checkHidden} from "../../../../Utils/Form/FormDynamic/Utils/checkHidden";
import {setArrayPath, setArrayPathForJs} from "../../../../Utils/Form/FormDynamic/Utils/setArrayPath";
import {useDeepCompareEffect, useDeepCompareMemo} from "use-deep-compare";

const defaultImage = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAASwAAAEsCAYAAAB5fY51AAAACXBIWXMAAA7EAAAOxAGVKw4bAAAF0WlUWHRYTUw6Y29tLmFkb2JlLnhtcAAAAAAAPD94cGFja2V0IGJlZ2luPSLvu78iIGlkPSJXNU0wTXBDZWhpSHpyZVN6TlRjemtjOWQiPz4gPHg6eG1wbWV0YSB4bWxuczp4PSJhZG9iZTpuczptZXRhLyIgeDp4bXB0az0iQWRvYmUgWE1QIENvcmUgOS4xLWMwMDIgNzkuYjdjNjRjY2Y5LCAyMDI0LzA3LzE2LTEyOjM5OjA0ICAgICAgICAiPiA8cmRmOlJERiB4bWxuczpyZGY9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkvMDIvMjItcmRmLXN5bnRheC1ucyMiPiA8cmRmOkRlc2NyaXB0aW9uIHJkZjphYm91dD0iIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtbG5zOmRjPSJodHRwOi8vcHVybC5vcmcvZGMvZWxlbWVudHMvMS4xLyIgeG1sbnM6cGhvdG9zaG9wPSJodHRwOi8vbnMuYWRvYmUuY29tL3Bob3Rvc2hvcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RFdnQ9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZUV2ZW50IyIgeG1wOkNyZWF0b3JUb29sPSJBZG9iZSBQaG90b3Nob3AgMjYuMCAoTWFjaW50b3NoKSIgeG1wOkNyZWF0ZURhdGU9IjIwMjUtMDEtMjZUMTQ6MTY6MzcrMDI6MDAiIHhtcDpNb2RpZnlEYXRlPSIyMDI1LTAxLTI2VDE0OjE5OjAxKzAyOjAwIiB4bXA6TWV0YWRhdGFEYXRlPSIyMDI1LTAxLTI2VDE0OjE5OjAxKzAyOjAwIiBkYzpmb3JtYXQ9ImltYWdlL3BuZyIgcGhvdG9zaG9wOkNvbG9yTW9kZT0iMyIgeG1wTU06SW5zdGFuY2VJRD0ieG1wLmlpZDphMmJlZmI4MC0xZjBiLTRlNjktYTY2MS04YWE4ODdiZGI4MGEiIHhtcE1NOkRvY3VtZW50SUQ9ImFkb2JlOmRvY2lkOnBob3Rvc2hvcDowOGRiZGFmOC00OGQ3LWJkNDUtOTRkMi00NDM2YTAzMjZlNWUiIHhtcE1NOk9yaWdpbmFsRG9jdW1lbnRJRD0ieG1wLmRpZDowMGMyZmNmMi1jYWY3LTQ1YTgtYTY5OC02ZmJhNDY3YWI3NzkiPiA8eG1wTU06SGlzdG9yeT4gPHJkZjpTZXE+IDxyZGY6bGkgc3RFdnQ6YWN0aW9uPSJjcmVhdGVkIiBzdEV2dDppbnN0YW5jZUlEPSJ4bXAuaWlkOjAwYzJmY2YyLWNhZjctNDVhOC1hNjk4LTZmYmE0NjdhYjc3OSIgc3RFdnQ6d2hlbj0iMjAyNS0wMS0yNlQxNDoxNjozNyswMjowMCIgc3RFdnQ6c29mdHdhcmVBZ2VudD0iQWRvYmUgUGhvdG9zaG9wIDI2LjAgKE1hY2ludG9zaCkiLz4gPHJkZjpsaSBzdEV2dDphY3Rpb249InNhdmVkIiBzdEV2dDppbnN0YW5jZUlEPSJ4bXAuaWlkOmEyYmVmYjgwLTFmMGItNGU2OS1hNjYxLThhYTg4N2JkYjgwYSIgc3RFdnQ6d2hlbj0iMjAyNS0wMS0yNlQxNDoxOTowMSswMjowMCIgc3RFdnQ6c29mdHdhcmVBZ2VudD0iQWRvYmUgUGhvdG9zaG9wIDI2LjAgKE1hY2ludG9zaCkiIHN0RXZ0OmNoYW5nZWQ9Ii8iLz4gPC9yZGY6U2VxPiA8L3htcE1NOkhpc3Rvcnk+IDwvcmRmOkRlc2NyaXB0aW9uPiA8L3JkZjpSREY+IDwveDp4bXBtZXRhPiA8P3hwYWNrZXQgZW5kPSJyIj8+Bfk8+wAABfBJREFUeJzt3dtx3DYAQNFsxiWkG/fmD/XmalLE5iPxjJPItiQ+gAuc86vRLLkgLikTJh/P5/M3gILfR28AwFsJFpAhWECGYAEZggVkCBaQIVhAhmABGYIFZAgWkCFYQIZgARmCBWQIFpAhWECGYAEZggVkCBaQIVhAhmABGYIFZAgWkCFYQIZgARmCBWQIFpAhWECGYAEZggVkCBaQIVhAhmABGYIFZAgWkCFYQIZgARmCBWQIFpAhWECGYAEZggVkCBaQIVhAhmABGYIFZAgWkCFYQIZgARmCBWQIFpAhWECGYAEZggVkCBaQIVhAhmABGYIFZAgWkCFYQIZgARmCBWQIFpAhWECGYAEZggVkCBaQIVhAhmABGYIFZAgWkCFYQIZgARmCBWQIFpAhWECGYAEZggVkCBaQIVhAhmABGYIFZAgWkCFYQIZgARmCBWQIFpAhWECGYAEZggVkCBaQIVhAhmABGYIFZAgWkCFYQIZgARmCBWQIFpAhWECGYAEZn0ZvQN3jy9fn6G2g4fny+TF6G+pcYR0gVryH4+U4wQIyBAvIECwgQ7CADMECMixruIhb2PtyN/A6rrCADMECMgQLyBAsIEOwgAzBAjIsa5jIj26HWyIBfxOsCfxq3c73PxcvduZPwoEeX74+37vI0KJEdiZYgxwJj2ixK8Ea4IzgiBY7Eqww0WI3gnWzsyMjWuxEsIAMwbqRqyE4RrCADMECMgQLyBAsIEOwgAzBupH/uAzHeFoDw7223EPceY1gxZUn9s/WpX37WXn/OJ8/CW9mAr6PxbZ8T7AGOCta5fi9J0SixTeCNcjR2OwSqyO/w3oEa6CPROf58vmxW6zgG8Ea7K0BqofqDGKHu4ST2CFGZz1pdYfvite5wuIWro44g2BxOU9Z5SyCRZJo7UmwuNSVYRGt/QgWlxEUziZYXOKuWIniXgSLPNHah2BxuhEBEa09CBanEg6uJFicZnSsRn8+1xMsliJaaxMsTjFTKGbaFs4lWBwmENxFsFiSiK7J42UW86OJetUjWWYOg0fRrMcV1kLe8haauz4PriBYi3hLPM4MTCVWle3kbQRrAd5A83M77vOqBCtuxBtoigEobjP/J1ibenz5+ucHf8/EZxjBCjsYjz9u/rzh6tuPYGWd9QaaM7alZMd9XolgBY2427fSRF9pX3YjWPySCc4sBCvm7gWgq8Zq1f1anWCFeAPNuXbc5zrBirhjcv33M3aY0Dvs40oEi1eZyMxIsALujMeOodpxn6sEa3LeQHOPHfe5SLAmZhLBvwkW/MMJYn6CNSmTZwzf+9wEa0ImzVi+/3kJFpAhWJNxdp+DcZiTYE3EJJmL8ZiPYE3C5JiTcZmLYAEZgjUBZ/G5GZ95CNZgJkODcZqDYA1kErQYr/EEC8gQrEGcrZuM21iCNYCDvs34jSNYN3Owr+Gjb87mGMGCj3n3m7M5TrBu5OpqLcbzfoJ1Ewf3mozrvQQLyBCsGzgLr8343kewLuZg3oNxvodgARmfRm/A6p4vnx+jtwFW4QoLyHCFdRH/pgHnc4UFZAgWkCFYQIZgARmCBWQI1gHWWPEejpfjHs+nu+9AgyssIEOwgAzBAjIEC8gQLCBDsIAMwQIyBAvIECwgQ7CADMECMgQLyBAsIEOwgAzBAjIEC8gQLCBDsIAMwQIyBAvIECwgQ7CADMECMgQLyBAsIEOwgAzBAjIEC8gQLCBDsIAMwQIyBAvIECwgQ7CADMECMgQLyBAsIEOwgAzBAjIEC8gQLCBDsIAMwQIyBAvIECwgQ7CADMECMgQLyBAsIEOwgAzBAjIEC8gQLCBDsIAMwQIyBAvIECwgQ7CADMECMgQLyBAsIEOwgAzBAjIEC8gQLCBDsIAMwQIyBAvIECwgQ7CADMECMgQLyBAsIEOwgAzBAjIEC8gQLCBDsIAMwQIyBAvIECwgQ7CADMECMgQLyBAsIEOwgAzBAjIEC8gQLCBDsIAMwQIyBAvIECwgQ7CADMECMgQLyBAsIEOwgAzBAjL+AnYiX6zyDiP5AAAAAElFTkSuQmCC";

const ImageScreenComponent = (props) => {
    const uploadFiledRef = useRef(null);
    const [loadingImage, setLoadingImage] = useState(true);
    const [imageContent, setImageContent] = useState(null);
    const [uploadAction, setUploadAction] = useState(false);
    const [uploadAvatar, setUploadAvatar] = useState(false);
    const [imgActions, setImgActions] = useState([]);
    const {appEnv} = useSelector(state => state.app)
    const {
        element: {properties = {}, styles: sourceStyles, events = []},
        screenName, doActions, actionsContext, containerArrayPath
    } = props;
    const globalValues = useSelector(state => state.jsonScreen.globalValues);
    const currentResolution = useCurrentResolution();
    const styles = useResponsiveStyles(sourceStyles, currentResolution);
    const border = generateBorder(styles);

    const id = useDeepCompareMemo(() => {
        return getParamsFromString(setArrayPathForJs(properties.sourceId, containerArrayPath), {...actionsContext, ...globalValues}, screenName);
    }, [properties.sourceId, containerArrayPath, actionsContext, globalValues, screenName]);

    const content = useDeepCompareMemo(() => {
        return getParamsFromString(setArrayPathForJs(properties.content, containerArrayPath), {...actionsContext, ...globalValues}, screenName);
    }, [properties.content, containerArrayPath, actionsContext, globalValues, screenName]);

    const publicUrl = useDeepCompareMemo(() => {
        return getParamsFromString(setArrayPathForJs(properties.publicUrl, containerArrayPath), {...actionsContext, ...globalValues}, screenName)
    }, [properties.publicUrl, containerArrayPath, actionsContext, globalValues, screenName]);

    const isHidden = useMemo(() => {
        return checkHidden({...globalValues, ...actionsContext}, properties.hideCondition, screenName);
    }, [JSON.stringify(globalValues), JSON.stringify(actionsContext), properties.hideCondition, screenName])

    useEffect(() => {
        const actions = events[0] ? events[0].actions : undefined;
        if (actions) {
            //used for selecting file from user's local files
            let isUpload = actions.findIndex((item) => item.type === 'uploadFile');
            if (isUpload !== -1) {
                let uploadAction = actions[isUpload];
                let arrayPath = setArrayPath(uploadAction.setToVar, containerArrayPath);
                setUploadAction({
                    ...uploadAction,
                    setToVar: uploadAction.setToVar ? arrayPath ? arrayPath : uploadAction.setToVar : undefined
                })
                return;
            }

            let isUploadAvatar = actions.findIndex((item) => item.type === 'uploadAvatar');
            if (isUploadAvatar !== -1) {
                let uploadAction = actions[isUploadAvatar];
                let arrayPath = setArrayPath(uploadAction.setToVar, containerArrayPath);
                setUploadAvatar({
                    ...uploadAction,
                    setToVar: uploadAction.setToVar ? arrayPath ? arrayPath : uploadAction.setToVar : undefined
                })
                return;
            }

            setImgActions(actions);

        }
        return () => {
            setImageContent(null)
        }
    }, []);

    useDeepCompareEffect(() => {
        setImage(id, content, publicUrl);
    }, [id, content, publicUrl]);

    function onClickImg() {
        if (imgActions && imgActions.length) {
            doActions(imgActions)
        }
    }

    async function setImage(imgId, imgContent, publicUrl) {
        setLoadingImage(true);
        let img = publicUrl ? publicUrl : imgContent ?
            imgContent :
            await getImage(imgId);
        if (publicUrl) {
            let currentUrl = publicUrl;
            //url should start with slash
            if (currentUrl.slice(0, 1) !== '/') {
                currentUrl = '/' + publicUrl
            }
            img = process.env.NODE_ENV === 'development' ?
                `${process.env.REACT_APP_REMOTE_HOST}${appEnv}${currentUrl}` :
                `/${appEnv}` + currentUrl;
        }

        setImageContent(img)
        setLoadingImage(false);
    }

    async function fileUpload(e) {
        let files = e.target.files;
        for (let i = 0; i < files.length; i++) {
            let file = files[i];

            let objUrl = URL.createObjectURL(file);
            let fileInfo = {
                name: file.name,
                type: uploadAvatar ? 'avatar' : uploadAction.fileType ? uploadAction.fileType : 'system',
                content: objUrl
            };
            const uploadActionWithResult =
                uploadAction ? {
                    ...uploadAction,
                    param: [{value: [fileInfo]}]
                } : {
                    ...uploadAvatar,
                    file: fileInfo
                };
            uploadAction && await setImage(undefined, objUrl, undefined)

            //reset field input, for firing event after uploading second time same image
            if(uploadAvatar) {
                uploadFiledRef.current.value = ""
            }

            doActions([uploadActionWithResult], actionsContext);
        }
    }

    if (uploadAction || uploadAvatar) {
        return (
            <div style={{padding: 2}}>
                <ImageUploadComponent
                    action={uploadAction || uploadAvatar}
                    border={border}
                    fileUpload={fileUpload}
                    imageContent={imageContent}
                    loadingImage={loadingImage}
                    styles={styles}
                    uploadFiledRef={uploadFiledRef}
                />
            </div>
        )
    }
    return <ImagePreviewComponent
        border={border}
        imageContent={imageContent}
        styles={styles}
        onClickFn={onClickImg}
        loadingImage={loadingImage}
        isHidden={isHidden}
    />
};
export default JsonScreenHoc(ImageScreenComponent);

ImageScreenComponent.propTypes = {
    element: PropTypes.object,
    screenName: PropTypes.string,
    globalValues: PropTypes.object
};

const ImagePreviewComponent = ({styles, border, imageContent, onClickFn, loadingImage, isHidden}) => {
    return (
        <Card
            onClick={onClickFn}
            className={styles.className}
            style={{
                position: 'relative',
                width: styles.width,
                height: styles.height,
                margin: styles.margin,
                padding: styles.padding,
                borderRadius: styles.borderRadius,
                boxShadow: `${styles.boxShadow} ${styles.shadowColor}`,
                background: 'transparent',
                display: !isHidden ? 'block' : 'none',
                // display: 'table',
                ...border,
                borderColor: styles.borderColor,
                borderStyle: styles.borderStyle || 'solid',
            }}>
            {loadingImage ? <Loading/> : (
                <CardMedia
                    image={imageContent ? imageContent : defaultImage}
                    component="img"
                />
            )}
        </Card>
    )
};

const ImageUploadComponent = ({styles, border, imageContent, action, fileUpload, loadingImage, uploadFiledRef}) => {
    const uniqueId = uid(action);
    let borderObj = generateBorder(styles);
    return (
        <>
            <input
                ref={uploadFiledRef}
                id={uniqueId} type="file" style={{display: "none"}} accept={'image/*'}
                   onChange={(e) => fileUpload(e)}/>
            <label htmlFor={uniqueId}>
                <Card style={{
                    width: styles.width,
                    height: styles.height,
                    margin: styles.margin,
                    padding: styles.padding,
                    ...borderObj,
                    borderColor: styles.borderColor,
                    borderRadius: styles.borderRadius,
                    boxShadow: `${styles.boxShadow} ${styles.shadowColor}`,
                    cursor: 'pointer',
                    position: 'relative',
                    ...border,
                }}>
                    <CardMedia
                        image={imageContent ? imageContent : defaultImage}
                        component="img"
                    />
                    {loadingImage && <Loading/>}
                </Card>
            </label>
        </>
    )
};

async function getImage(currentId) {
    try {
        const result = currentId ? await request({
            url: 'files/getFiles',
            method: "POST",
            data: {id: currentId || ""}
        }) : {content: defaultImage};
        return result.content;
    } catch (e) {
        console.log(e);
        return undefined;
    }
}
